import { render } from "./OrderRouting.vue?vue&type=template&id=03b3c8fb"
import script from "./OrderRouting.vue?vue&type=script&lang=js"
export * from "./OrderRouting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__